import PropTypes from 'prop-types'

import NumericFieldWithIncrement from '../../../../FormLegacy/FormFieldsV2/NumericFieldWithIncrement'

import FormInput from './FormInput'

const NumericInput = ({
  columnSize,
  label,
  value,
  name,
  errorText,
  setFieldValue,
  onlyIntegers,
  min,
  max,
  onlyPositive = true,
}) => {
  const minExists = min !== undefined
  const maxExists = max !== undefined

  return (
    <div className={`column is-${columnSize}`}>
      <FormInput label={label} name={name}>
        <NumericFieldWithIncrement
          onlyPositive={onlyPositive}
          isError={value < 0}
          name={name}
          value={value}
          onChange={(e) => {
            if (e.target.value.length > 15) {
              return
            }
            const value = parseFloat(e.target.value)
            if (minExists && value < min) {
              return
            }

            if (maxExists && value > max) {
              return
            }
            setFieldValue(name, value)
          }}
          onIncrement={(e) => {
            const value = e.target.value || 0
            if (maxExists && value > max) {
              return
            }
            setFieldValue(name, value)
          }}
          onDecrement={(e) => {
            const value = e.target.value || 0
            if (minExists && value < min) {
              return
            }
            setFieldValue(name, value)
          }}
          onBlur={(e) => {
            if (!onlyIntegers) {
              return
            }
            setFieldValue(name, parseInt(e.target.value))
          }}
          allowZero
        />
        {errorText && <p className="event-form-input__error">{errorText}</p>}
      </FormInput>
    </div>
  )
}

NumericInput.propTypes = {
  columnSize: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  errorText: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  onlyIntegers: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  onlyPositive: PropTypes.bool,
}

export default NumericInput
